var Roles = /** @class */ (function () {
    function Roles(form) {
        this.Form = form;
        this.init();
    }
    Roles.prototype.init = function () {
        jQuery(this.Form.querySelector('select.roles')).ac_select2({
            placeholder: acp_layouts.roles,
            theme: 'acs2'
        })
            .on("select2:select", function () {
            jQuery(this).ac_select2('open');
        })
            .on("select2:open", function () {
            setTimeout(function () {
                jQuery('.select2-container.select2-container--open .select2-dropdown li[role=group]').each(function () {
                    if (jQuery(this).find('li[aria-selected=false]').length > 0) {
                        jQuery(this).show();
                    }
                    else {
                        jQuery(this).hide();
                    }
                });
            }, 1);
        });
    };
    return Roles;
}());
export default Roles;
